import { ActionTypes } from "../reducers/patientOCR.selector.reducers";

export const setCurrentAttachment = attachment => ({
  type: ActionTypes.SET_CURRENT_ATTACHMENT,
  payload: attachment,
});

export const resetCurrentAttachment = () => ({
  type: ActionTypes.RESET_CURRENT_ATTACHMENT,
});

export const setCurrentReport = report => ({
  type: ActionTypes.SET_CURRENT_REPORT,
  payload: report,
});

export const resetCurrentReport = () => ({
  type: ActionTypes.RESET_CURRENT_REPORT,
});
